import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ShortcutConfigModal, { getShortcutIcon } from './ShortcutConfigModal';

const HomeShortcutsBar = ({ shortcuts = [], onSaveShortcuts }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const handleNavigate = (path) => {
    if (!path) return;
    if (path.startsWith('http')) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, sm: 1.5 },
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          gap: { xs: 1, sm: 1.5 },
          flex: 1,
          minWidth: 0,
        }}
      >
        {shortcuts.slice(0, 4).map((shortcut, index) => (
          <Box
            key={shortcut.id || index}
            onClick={() => handleNavigate(shortcut.path)}
            sx={{
              background: 'linear-gradient(135deg, #2b84bf 0%, #3a97d4 100%)',
              color: 'white',
              borderRadius: '16px',
              p: { xs: 0.8, sm: 1 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: { xs: '68px', sm: '74px' },
              minWidth: 0,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(37, 126, 185, 0.25)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 18px rgba(37, 126, 185, 0.35)',
              },
            }}
          >
            <Box sx={{ mb: 0.8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {getShortcutIcon(shortcut.icon)}
            </Box>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                fontSize: { xs: '0.75rem', sm: '0.85rem' },
                textAlign: 'center',
                letterSpacing: 0.2,
                color: '#ffffff',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              {shortcut.title}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Plus Button to customize */}
      <Tooltip title="Personalizar accesos directos">
        <IconButton
          onClick={() => setModalOpen(true)}
          sx={{
            width: 36,
            height: 36,
            bgcolor: '#38bdf8',
            color: 'white',
            '&:hover': { bgcolor: '#0284c7' },
            boxShadow: '0 2px 8px rgba(56, 189, 248, 0.4)',
            flexShrink: 0,
          }}
        >
          <Add fontSize="small" />
        </IconButton>
      </Tooltip>

      <ShortcutConfigModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        currentShortcuts={shortcuts}
        onSave={onSaveShortcuts}
      />
    </Box>
  );
};

HomeShortcutsBar.propTypes = {
  shortcuts: PropTypes.array,
  onSaveShortcuts: PropTypes.func.isRequired,
};

export default HomeShortcutsBar;

